import type FriendModel from '../../../models/FriendModel';
import { requestAndParse, requestSuccessful } from '../request';

const getFriends = async () => {
    const route = 'user/get-friends';
    const payload = {};

    const response = await requestAndParse(route, payload, 'GET');

    const friends = (response.body?.friends ?? []) as FriendModel[];

    friends.sort((a, b) => {
        if (a.name === b.name) {
            return a.username < b.username ? -1 : 1;
        }

        return a.name < b.name ? -1 : 1;
    });

    return {
        friends,
        success: requestSuccessful(response),
        error: response.body?.message as string | undefined,
    };
};

export default getFriends;
